import axios from "axios";
export const getToken = () => {
  let cpyTkn = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImFwcElkLWRmZWU5ZjE2LTIxYjUtNDg4Ni04MDE3LTA3Yzc4NTMxYTY1Yi0yMDIyLTEyLTEyVDExOjUxOjU3LjIzOCIsInZlciI6NH0.eyJpc3MiOiJodHRwczovL2V1LWRlLmFwcGlkLmNsb3VkLmlibS5jb20vb2F1dGgvdjQvZGZlZTlmMTYtMjFiNS00ODg2LTgwMTctMDdjNzg1MzFhNjViIiwiZXhwIjoxNjcyMjA3MzMwLCJhdWQiOlsiZDZkMTA1OTYtN2MzOS00Yzk4LWFmYTgtYThkMzI4ZjZhMTEwIl0sInN1YiI6ImE4YTcwZWEzLTYzMTYtNGU3OS1iODE1LTUzYTBmNTM3ZDJhMSIsImFtciI6WyJhcHBpZF9jdXN0b20iXSwiaWF0IjoxNjcyMTIwOTMwLCJ0ZW5hbnQiOiJkZmVlOWYxNi0yMWI1LTQ4ODYtODAxNy0wN2M3ODUzMWE2NWIiLCJzY29wZSI6Im9wZW5pZCBhcHBpZF9kZWZhdWx0IGFwcGlkX3JlYWR1c2VyYXR0ciBhcHBpZF9yZWFkcHJvZmlsZSBhcHBpZF93cml0ZXVzZXJhdHRyIGFwcGlkX2F1dGhlbnRpY2F0ZWQifQ.kOeXvqBpkzBEQqvz0lZ_auHN6gWm-8q0boiMyfs4HfcOefpICFRZQAgVN86s77CY7OQvTWwNwgZMlueImiMDBAVng2Iu1W466QfP_M8qhA-FZjL7XoOEXoSfEx5taGS-TAykd0xnUI18SbQkSLtoaWJYbL06OtPKt18olMhUJemFDa6AiHKzZdgDM2-0_U5xniEShlODFivlYqhRgqlxgLlzW-ZRtGvqN5RNR4oQYa656eFSWnU2J72b910PhyfylVZD6dY3Pk19IYHZVQ3rAT8nBsa8fRj_yXZ3boRagz0L6ZTqw4zq1SjNKZbmIeldu5nW8qnD86Jte2WMdtm6pg";
  let token = localStorage.getItem("token") 
  return token;
};

const getApiResponse = async ({ method, url, token, body }) => {
  let request = {
    method,
    url,
    headers: {
      "Content-Type": "application/json",
    },
  };
  const tokens = await getToken();
  request = body ? { ...request, data: { ...body } } : request;

  request = token
    ? {
        ...request,
        headers: { ...request.headers, Authorization: tokens },
      }
    : request;
  return axios({
    ...request,
  });
};

export const getResponseData = async (Payload) => {
  try {
    const getdata = await getApiResponse(Payload);
    console.log("getdata", getdata);
    return getdata.data;
  } catch (e) {
    return e?.status;
  }
};

const getPrefixURL = (type) => {
  let prefixURL;
  if (type === "Job") {
    prefixURL = "https://whc-job-management-whc";
  }
  else if (type === "Profile") {
    prefixURL = "https://whc-profile-management-whc";
  }
  else if (type === "Catalog") {
    prefixURL = "https://whc-catalog-management-whc";
  }
  else if (type === "Quote") {
    prefixURL = "https://whc-quote-management-whc";
  }

  return prefixURL;
};

export const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: "" }) =>
  async (payload) => {
    const { url } = payload;
    let prefixUrl = getPrefixURL(payload.prefixUrlType);
    let finalURL =  prefixUrl + baseUrl + url;
    console.log("fullurl", finalURL);
    const payloads = { ...payload, url: finalURL};
    try {
      const result = await getApiResponse(payloads);
      if (result?.data && result?.data?.error) {
        const error = {
          status: 200,
          data: result?.data?.error,
        };
        throw error;
      } else {
        return { data: result.data };
      }
    }
    catch (axiosError) {
      const err = axiosError.response;
      console.log(err)
      return {
        error: {
          status: err?.status,
          data: err?.data,
        },
      };
    }
    
   
  };
